const AbstractSyncer = require('@/lib/Syncing/AbstractSyncer');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const EventNames = require('@/lib/Events/EventNames');
const LocalStorageKeys = require('@/lib/Storage/LocalStorageKeys');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');

/**
 * The ItemsSyncer class is used to sync items where branch is important like tickets or products.
 * If the branch is not important the DataSyncer should be used.
 */
class ItemsSyncer extends AbstractSyncer {
    // This duplication of parameters being passed to the superclass' constructor looks silly but it's
    // necessary for Angular's injector to work.
    constructor(
        $injector,
        dataStore,
        eventBus,
        localStorageDataStore,
        syncStateManager
    ) {
        super(
            $injector,
            dataStore,
            eventBus,
            localStorageDataStore,
            syncStateManager
        );

        /**
         * @type {ConsoleLogger}
         */
        this.log = logFactory('ItemsSyncer');
    }

    getManagedTableNames() {
        return [
            DataStoreNames.GIFT_VOUCHERS,
            DataStoreNames.ITEM_BARCODES,
            DataStoreNames.ITEM_OPTIONS,
            DataStoreNames.MEMBERSHIP_PLANS,
            DataStoreNames.OPTION_SETS,
            DataStoreNames.PRODUCTS,
            DataStoreNames.SESSIONS,
            DataStoreNames.TICKETS,
        ];
    }

    getSyncFunctions() {
        return [
            this.createSyncRepositoryFunction(DataStoreNames.GIFT_VOUCHERS, 'giftVoucherRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.ITEM_OPTIONS, 'itemOptionRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.MEMBERSHIP_PLANS, 'membershipPlanRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.OPTION_SETS, 'optionSetRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.PRODUCTS, 'productRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.SESSIONS, 'sessionRepository'),
            this.createSyncRepositoryFunction(DataStoreNames.TICKETS, 'ticketRepository'),

            // This isn't really something that needs syncing.
            // It just needs booting up after the above stuff is synced.
            {
                name: 'items',
                parallel: false,
                func: () => {
                    /**
                     * @type {SaleableItemService}
                     */
                    const saleableItemService = this.$injector.get('saleableItemService');
                    return saleableItemService.load();
                },
            },
        ];
    }

    requiresBranch() {
        return true;
    }

    async clear() {
        this.localStorageDataStore.removeByPrefix(LocalStorageKeys.LAST_ITEM_OPTIONS_ERROR_HASH);

        return super.clear();
    }

    onSyncFinish() {
        this.eventBus.broadcast(EventNames.ITEMS_SYNCED);
    }
}

module.exports = ItemsSyncer;
